import analyticsService, { AnalyticsEvent } from 'services/AnalyticsService';
import { consumerIdSelector } from 'store/profile/selectors';
import { Thunk } from 'store/types';
import * as selectors from './selectors';
import * as types from './types';

const KEY = 'PROFILE';

// shared ui data actions
export const GET_CONSUMER_SHARED_UI_DATA = `${KEY}.GET_CONSUMER_SHARED_UI_DATA`;
export const GET_CONSUMER_SHARED_UI_DATA_SUCCESS = `${KEY}.GET_CONSUMER_SHARED_UI_DATA_SUCCESS`;
export const GET_CONSUMER_SHARED_UI_DATA_FAIL = `${KEY}.GET_CONSUMER_SHARED_UI_DATA_FAIL`;

export const getConsumerSharedUiData = (consumerId: string, useRequestState = true) => ({
  type: GET_CONSUMER_SHARED_UI_DATA,
  payload: {
    useRequestState,
    requestStateSelector: selectors.consumerUiDataRequestStateSelector,
    client: 'preference',
    request: {
      headers: { consumerid: consumerId },
      method: 'get',
      url: '/consumerpreferences/sharedUiData'
    }
  }
});

export const UPDATE_CONSUMER_SHARED_UI_DATA = `${KEY}.UPDATE_CONSUMER_SHARED_UI_DATA`;
export const UPDATE_CONSUMER_SHARED_UI_DATA_SUCCESS = `${KEY}.UPDATE_CONSUMER_SHARED_UI_DATA_SUCCESS`;
export const UPDATE_CONSUMER_SHARED_UI_DATA_FAIL = `${KEY}.UPDATE_CONSUMER_SHARED_UI_DATA_FAIL`;

export const updateConsumerSharedUiData = (
  consumerId: string,
  sharedUiData: types.ConsumerSharedUiData
): Thunk => (dispatch, getState) =>
  dispatch({
    type: UPDATE_CONSUMER_SHARED_UI_DATA,
    payload: {
      client: 'preference',
      request: {
        headers: { consumerid: consumerId },
        method: 'post',
        url: '/consumerpreferences/sharedUiData',
        data: {
          ...selectors.sharedUiDataSelector(getState()),
          ...sharedUiData
        }
      }
    }
  });

export const UPDATE_CONSUMER_AVATAR = `${KEY}.UPDATE_CONSUMER_AVATAR`;
export const UPDATE_CONSUMER_AVATAR_SUCCESS = `${KEY}.UPDATE_CONSUMER_AVATAR_SUCCESS`;
export const UPDATE_CONSUMER_AVATAR_FAIL = `${KEY}.UPDATE_CONSUMER_AVATAR_FAIL`;

export const updateConsumerAvatar = (
  avatars: types.Avatar[],
  newAvatarId: string | undefined,
  oldAvatarId: string,
  userSelectedConsumerId: string
): Thunk => async (dispatch, getState) => {
  const state = getState();
  const consumerid = consumerIdSelector(state);
  const res = await dispatch({
    type: UPDATE_CONSUMER_AVATAR,
    payload: {
      client: 'preference',
      request: {
        headers: { consumerid },
        method: 'put',
        url: '/consumerpreferences/sharedUiData',
        data: {
          ...selectors.sharedUiDataSelector(getState()),
          avatars: [...avatars]
        }
      }
    }
  });

  if (!res.error) {
    analyticsService.logEvent(AnalyticsEvent.AvatarSelectionComplete, {
      /* eslint-disable @typescript-eslint/camelcase */
      isProxy: userSelectedConsumerId === consumerid ? 'No' : 'Yes',
      old_avatar_id: oldAvatarId,
      new_avatar_id: newAvatarId || 'Initials'
    });
  }

  return res;
};

export const updateAndRefreshSharedUiData = (
  sharedUiData: types.ConsumerSharedUiData
): Thunk => async (dispatch, getState) => {
  const consumerId = consumerIdSelector(getState());

  if (!consumerId) {
    return 'no consumer id';
  }

  try {
    await dispatch(updateConsumerSharedUiData(consumerId, sharedUiData));

    return dispatch(getConsumerSharedUiData(consumerId, false));
  } catch (err) {
    return err;
  }
};
